module.exports = __webpack_public_path__ + "img/KP.770cb198.svg";